import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 진행률 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 진행 예정 ")

import {computed, toRefs} from 'vue'
import {AgBoxS} from '@/components/ag'
import {currency, getMonthDay} from '@/utils/filters'


export default /*#__PURE__*/_defineComponent({
  props: {
  backgroundImg: {type: String},
  id: {default: '', type: String},
  isLogin: {default: false, type: Boolean},
  isShowPricePerStock: {type: Boolean},
  kind: {default: '', type: String},
  openingDate: {default: '', type: String},
  pricePerStock: {default: '', type: String},
  progress: {default: 0, type: Number},
  title: {default: '', type: String},
},
  emits: ['open'],
  setup(__props, { emit: emits }) {

const props = __props



const {id, openingDate, progress, pricePerStock, title} = toRefs(props)



const formattedPricePerStock = computed(() => {
  return currency(pricePerStock.value)
})

const formattedProgress = computed(() => {
  return currency(progress.value * 100)
})

const formattedOpeningDate = computed(() => {
  return getMonthDay(openingDate.value as any)
})

const progressColor = computed(() => {
  return progress.value > 0.5 ? 'red1' : 'sky1'
})

const onClick = () => {
  emits('open', {
    id: id.value,
    title: title.value,
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), {
    css: {
      width: 200,
      height: 152,
      corner: 10,
      bg: 'white',
      boxShadow: '0px 2px 8px rgba(174, 182, 199, 0.2)',
      position: 'relative',
      overflow: 'hidden',
      shrink: 0,
      mr: 8,
    },
    onClick: onClick
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), { css: {width: '100%', height: 72} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), {
            "container-as": "img",
            src: __props.backgroundImg,
            css: {position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover'}
          }, null, 8, ["src"]),
          _createVNode(_unref(AgBoxS), { css: {
          boxShadow: 'inset 0px 0px 80px rgba(0, 0, 0, 0.6)',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          position: 'absolute',
        } }, null, 8, ["css"]),
          _createVNode(_unref(AgBoxS), { css: {typography: 'tit18b', color: 'white', height: '100%', px: 16, py: 12} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)) + " > ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {p: 16} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row', alignItems: 'center'} }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), { css: {typography: 'main13r', color: '#8F929B', mr: 8} }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (__props.isLogin)
                ? (_openBlock(), _createBlock(_unref(AgBoxS), {
                    key: 0,
                    css: {dp: 'flex', direction: 'row', alignItems: 'center'}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AgBoxS), { css: {typography: 'num14eb', mr: 4} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formattedPricePerStock)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(AgBoxS), { css: {typography: 'main14r'} }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(AgBoxS), {
                    key: 1,
                    css: {typography: 'main13r', color: '#8F929B', mr: 8}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          (__props.kind === 'collecting')
            ? (_openBlock(), _createBlock(_unref(AgBoxS), {
                key: 0,
                css: {dp: 'flex', direction: 'row', alignItems: 'center'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), { css: {mr: 8, color: '#8F929B', typography: 'main13r'} }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgBoxS), {
                    css: {color: _unref(progressColor),}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formattedProgress)) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["css"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(AgBoxS), {
                key: 1,
                css: {dp: 'flex', direction: 'row'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), { css: {mr: 8, color: '#8F929B', typography: 'main13r'} }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AgBoxS), { css: { } }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formattedOpeningDate)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["css"]))
}
}

})